import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import api from "../api/api";

import PageRenderer from "../components/page-renderer/PageRenderer";

const BASE_URL = "https://imagensdaface.com.br";

export default function PublicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);

  useEffect(() => {
    api.get(`/pages/${slug}`).then((res) => {
      if (res.data.exists) {
        setPage(res.data.page);
      }
    });
  }, [slug]);

  if (!page) return <div className="p-10">Página não encontrada</div>;

  const seo = page.content?.seo || {};

  const title = seo.title || "Plataforma";
  const description = seo.description || "";
  const ogTitle = seo.ogTitle || title;
  const ogDescription = seo.ogDescription || description;
  const ogImage = seo.ogImage || "";

  const canonicalUrl = `${BASE_URL}/p/${slug}`;

  return (
    <>
      <Helmet>
        {/* SEO BÁSICO */}
        <title>{title}</title>
        {description && (
          <meta name="description" content={description} />
        )}
        {seo.keywords && (
          <meta name="keywords" content={seo.keywords} />
        )}

        {/* CANONICAL */}
        <link rel="canonical" href={canonicalUrl} />

        {/* OPEN GRAPH */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        {ogImage && (
          <meta property="og:image" content={ogImage} />
        )}
      </Helmet>

      <PageRenderer content={page.content} />
    </>
  );
}
